import React from "react"
import SettingsSection from "components/settings/SettingsSection"
import {
  Box, Image, Stack, Text,
} from "@chakra-ui/react"
import Link from "components/elements/Link"
import { iOSAppURL } from "utilities/routes"
import download from "assets/images/download-from-app-store.png"
import badgePrintingPreview from "assets/images/badge-printing-ios-app-preview.png"
import UpgradeAlert from "components/elements/UpgradeAlert"
import { BADGE_PRINTING_ARTICLE_URL, DIOBOX_APP_LINK } from "utilities/externalLinks"

type Props = {
  enabled: boolean
}

const BadgePrinting = ({ enabled }: Props) => (
  <SettingsSection title="Badge Printing">
    <Stack spacing={10} align="center">
      <Stack gap={8} borderRadius="xl" bgColor="white" borderWidth={1} p={6}>
        <Stack gap={4}>
          <Text>
            Manage the complete badge production process from start to finish on the{" "}
            <Link isExternal href={DIOBOX_APP_LINK}>Diobox iOS App.</Link><br />
            Print personalized, branded badges instantly at check-in to reduce delays
            and minimize manual errors. Select from a range of templates and customize
            them to match your event branding.
          </Text>
          <Text>
            Diobox’s proprietary QR code system supports multi-purchase QR codes for
            check-in and contact exchange via the standard vCard protocol.
          </Text>
          <Text>
            To learn more, see:{" "}
            <Link isExternal href={BADGE_PRINTING_ARTICLE_URL}>
              Badge Printing Help Articles
            </Link>
          </Text>
        </Stack>
        <Image src={badgePrintingPreview} />
      </Stack>
      <Link w={130} display="block" href={iOSAppURL} isExternal>
        <Image src={download} />
      </Link>
      {!enabled && <Box w="full"><UpgradeAlert text="Feature requires a Professional Subscription or above." /></Box>}
    </Stack>
  </SettingsSection>
)

export default BadgePrinting
